import * as React from 'react';
import { styled } from '@mui/material/styles';
import Accordion, { AccordionProps, accordionClasses } from '@mui/material/Accordion';

interface EnhancedAccordionProps extends AccordionProps {
  gutter?: number;
  dividerColor?: string;
}

export const EnhancedAccordion = styled(({ ...props }: EnhancedAccordionProps) => <Accordion {...props} />, {
  shouldForwardProp: (prop) => !['gutter', 'dividerColor'].includes(prop as any),
})((props) => ({
  [`&.${accordionClasses.root}::before`]: {
    backgroundColor: props.dividerColor,
  },
  [`&.${accordionClasses.disabled}`]: {
    backgroundColor: `#f7f7f7`,
    cursor: 'not-allowed',
  },
  [`&.${accordionClasses.expanded}`]: {
    marginTop: props.gutter,
    marginBottom: props.gutter,
  },
}));
